import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { toast } from "sonner";

const STATUS = { nuovo: "Nuovo", assegnato: "Assegnato", contattato: "Contattato", chiuso: "Chiuso" };

export default function Leads() {
  const [items, setItems] = useState([]);
  const [agencies, setAgencies] = useState([]);
  const [filter, setFilter] = useState("");
  const [inoltraFor, setInoltraFor] = useState(null); // lead object

  const load = () => api.get(`/leads${filter ? `?status=${filter}` : ""}`).then((r) => setItems(r.data));
  useEffect(() => { load(); api.get("/agencies").then((r) => setAgencies(r.data)); }, [filter]);

  const update = async (id, patch) => {
    try { await api.put(`/leads/${id}`, patch); load(); toast.success("Aggiornato"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const del = async (id, nome) => {
    if (!window.confirm(`Eliminare la richiesta di ${nome}? L'operazione non è reversibile.`)) return;
    try { await api.delete(`/leads/${id}`); load(); toast.success("Richiesta eliminata"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div data-testid="leads-page">
      <div className="flex justify-between items-end mb-8">
        <div>
          <div className="label-uppercase">Inbox</div>
          <h1 className="font-serif text-4xl mt-2">Richieste dal form pubblico</h1>
          <p className="text-sm text-[#5C5657] mt-2">Ogni richiesta arriva in questa inbox. L'inoltro all'agenzia partner è sempre manuale e viene tracciato nel <a className="hover:text-[#7D2E3F] underline" href="/admin/registro-richieste">Registro Richieste</a>.</p>
        </div>
        <select value={filter} onChange={(e) => setFilter(e.target.value)} className="admin-input w-48" data-testid="leads-filter">
          <option value="">Tutte</option>
          {Object.entries(STATUS).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
      </div>

      <div className="space-y-4">
        {items.map((l) => {
          const inoltrato = !!l.agenzia_assegnata_id;
          const agenziaNome = agencies.find(a => a.id === l.agenzia_assegnata_id)?.name;
          const prefNome = agencies.find(a => a.id === l.agenzia_preferita_id)?.name;
          return (
            <div key={l.id} data-testid={`lead-${l.id}`} className="admin-card p-6">
              <div className="flex justify-between items-start gap-4">
                <div className="flex-1">
                  <div className="label-uppercase">{new Date(l.created_at).toLocaleString("it-IT")}</div>
                  <h3 className="font-serif text-2xl mt-1">{l.nome}</h3>
                  <div className="text-sm text-[#5C5657] mt-1">
                    <a href={`mailto:${l.email}`} className="hover:text-[#7D2E3F]">{l.email}</a> · <a href={`tel:${l.telefono}`} className="hover:text-[#7D2E3F]">{l.telefono}</a>
                  </div>
                  <div className="text-sm mt-2">{l.tipo_immobile} · {l.comune ? `${l.comune} (${l.provincia})` : l.provincia}</div>
                  {prefNome && !inoltrato && (
                    <div className="text-xs mt-2 text-[#91590F]">Preferenza venditore: <strong>{prefNome}</strong></div>
                  )}
                  {l.note && <div className="mt-2 text-sm border-l-2 border-[#7D2E3F] pl-3 text-[#5C5657]">{l.note}</div>}
                </div>
                <div className="flex flex-col items-end gap-2 shrink-0">
                  <span className={`badge-stamp ${l.status === "nuovo" ? "badge-criticita" : "badge-pronto"}`}>{STATUS[l.status] || l.status}</span>
                  <button
                    data-testid={`lead-delete-${l.id}`}
                    onClick={() => del(l.id, l.nome)}
                    className="text-xs label-uppercase text-[#B3261E] hover:underline"
                  >
                    Elimina
                  </button>
                </div>
              </div>
              <hr className="my-4 border-[#E6E4E0]" />
              {inoltrato ? (
                <div className="grid md:grid-cols-3 gap-4 items-end">
                  <div>
                    <label className="label-uppercase">Agenzia assegnata</label>
                    <div className="mt-1 font-serif text-lg text-[#3A3D42]">{agenziaNome || "—"}</div>
                    <div className="text-xs text-[#8A8484] mt-1">
                      Inoltrata il {l.inoltrato_at ? new Date(l.inoltrato_at).toLocaleString("it-IT") : "—"} · Criterio: {l.criterio_assegnazione || "manuale"}
                    </div>
                  </div>
                  <div>
                    <label className="label-uppercase">Stato</label>
                    <select value={l.status} onChange={(e) => update(l.id, { status: e.target.value })} className="admin-input" data-testid={`lead-status-${l.id}`}>
                      {Object.entries(STATUS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                    </select>
                  </div>
                  <div>
                    <label className="label-uppercase">Note interne</label>
                    <input defaultValue={l.note_interne || ""} onBlur={(e) => e.target.value !== l.note_interne && update(l.id, { note_interne: e.target.value })} className="admin-input" />
                  </div>
                </div>
              ) : (
                <div className="flex items-center justify-between gap-4">
                  <div className="text-sm text-[#5C5657]">
                    Non ancora inoltrata. Puoi assegnarla manualmente a un'agenzia partner.
                  </div>
                  <button
                    data-testid={`lead-inoltra-${l.id}`}
                    onClick={() => setInoltraFor(l)}
                    className="btn-primary text-sm"
                  >
                    Inoltra all'agenzia
                  </button>
                </div>
              )}
            </div>
          );
        })}
        {items.length === 0 && <div className="admin-card p-16 text-center text-[#5C5657]">Nessuna richiesta</div>}
      </div>

      {inoltraFor && (
        <InoltraModal
          lead={inoltraFor}
          agencies={agencies}
          onClose={() => setInoltraFor(null)}
          onDone={() => { setInoltraFor(null); load(); }}
        />
      )}
    </div>
  );
}

function InoltraModal({ lead, agencies, onClose, onDone }) {
  const pref = agencies.find(a => a.id === lead.agenzia_preferita_id);
  const [agencyId, setAgencyId] = useState(lead.agenzia_preferita_id || "");
  const [criterio, setCriterio] = useState(lead.agenzia_preferita_id ? "preferenza_venditore" : "manuale");
  const [loading, setLoading] = useState(false);
  const CRITERI = {
    preferenza_venditore: "Preferenza venditore",
    rotazione: "Rotazione",
    manuale: "Assegnazione manuale",
  };
  const submit = async (e) => {
    e.preventDefault();
    if (!agencyId) { toast.error("Seleziona un'agenzia"); return; }
    setLoading(true);
    try {
      await api.post(`/leads/${lead.id}/inoltra`, { agency_id: agencyId, criterio });
      toast.success("Richiesta inoltrata. Email inviata all'agenzia.");
      onDone();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Errore");
    } finally { setLoading(false); }
  };
  return (
    <div className="fixed inset-0 z-50 bg-[#3A3D42]/60 flex items-start justify-center overflow-auto p-4" data-testid="inoltra-modal">
      <div className="bg-white border border-[#E6E4E0] w-full max-w-lg mt-16 mb-16" onClick={(e) => e.stopPropagation()}>
        <div className="p-8">
          <div className="flex justify-between items-start mb-2">
            <div>
              <div className="label-uppercase text-[#7D2E3F]">Inoltra richiesta</div>
              <h2 className="font-serif text-3xl mt-2 leading-tight">{lead.nome}</h2>
              <div className="text-sm text-[#5C5657] mt-1">{lead.tipo_immobile} · {lead.comune ? `${lead.comune} (${lead.provincia})` : lead.provincia}</div>
            </div>
            <button onClick={onClose} className="text-[#5C5657] text-xl">×</button>
          </div>
          {pref && (
            <div className="mt-4 p-3 border border-[#E6E4E0] bg-[#FBFAF7] text-sm">
              <div className="label-uppercase text-[#91590F] text-[10px]">Preferenza espressa dal venditore</div>
              <div className="mt-1 text-[#3A3D42]"><strong>{pref.name}</strong> — {pref.comune}</div>
            </div>
          )}
          <form onSubmit={submit} className="space-y-5 mt-6">
            <div>
              <label className="label-uppercase">Agenzia *</label>
              <select
                required
                data-testid="inoltra-agency"
                value={agencyId}
                onChange={(e) => setAgencyId(e.target.value)}
                className="admin-input"
              >
                <option value="">— Seleziona un'agenzia —</option>
                {agencies.map(a => (
                  <option key={a.id} value={a.id}>{a.name} — {a.comune}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="label-uppercase">Criterio *</label>
              <select
                required
                data-testid="inoltra-criterio"
                value={criterio}
                onChange={(e) => setCriterio(e.target.value)}
                className="admin-input"
              >
                {Object.entries(CRITERI).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
              </select>
              <p className="text-xs text-[#8A8484] mt-2">
                Il criterio viene salvato nel Registro Richieste immutabile per tracciabilità e opponibilità.
              </p>
            </div>
            <div className="pt-4 border-t border-[#E6E4E0] flex justify-end gap-3">
              <button type="button" onClick={onClose} className="btn-secondary">Annulla</button>
              <button type="submit" disabled={loading} data-testid="inoltra-submit" className="btn-primary">
                {loading ? "Invio…" : "Conferma inoltro"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
